import FouGroup from 'components/layout/fou-group/'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import Misc from 'src/utils/helper/misc'
import FouTextArea from 'src/components/form/text-area/index.vue'
import { errors as submissionErrors } from 'src/pages/submissions/script/common.data'

export default {
  name: 'customerMessage',

  data() {
    return {
      customerMessage: '',
      bannedWordforCustomerMessage: false,
    }
  },

  props: {
    fontResults: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: String,
      default: ''
    },
    as: {
      type: String,
      default: ''
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    FouGroup,
    FouTextArea
  },

  watch: {
    errors: {
      handler(newVal) {
        if (typeof newVal === 'object' && newVal !== null && !Object.hasOwn(newVal, 'customerMessage uploads')) {
          submissionErrors.value = submissionErrors.value.filter(
            error => !Object.hasOwn(error, 'customerMessage uploads')
          )
        }
      },
      immediate: true
    }
  },

  computed: {
    ...SubmissionComputed
  },

  methods: {
    ...SubmissionMethods,
    ...Misc,
    updateCustomerMessage() {
      this.submissionCustomerMessage = this.customerMessage
      this.updateSubmission()
    },
    getCustomerMessage() {
      this.customerMessage = this.submissionCustomerMessage
    }
  },

  created() {
    this.getCustomerMessage()
    this.$events?.$on('unset:customer:message', () => {
      this.customerMessage = ''
    })
  },
  beforeUnmount() {
    this.$events.$off('unset:customer:message')
  }
}
